import Header from "./Components/Header";
import Banner from "./Components/Banner";
import MainContent from './Components/MainContent';
import Form from './Components/Form'
import Footer from "./Components/Footer";
import './App.css';


function App() {
  return (
    <div>
      <Header />
      <Banner />
      <MainContent />
      <Form />
      <Footer />
    </div>
  );
}

export default App;
